/**
 * FinalCta — closing block: soft glow, headline, sub, one black CTA, App Store badge, note.
 * The landing uses the defaults (approved copy); the guide pages pass their own
 * title / sub / button and `small`.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../components/v2/Icon.jsx';
import { APP_STORE_URL } from '../../lib/appStore.js';
import { useStr } from './useStr.js';

export default function FinalCta({ title, sub, btn, to = '/signup', small = false, note = true }) {
  const { t, ar, arrow } = useStr();
  return (
    <section className="sx">
      <div className="wrap">
        <div className={`cta${small ? ' sm' : ''}`}>
          <div className="glow ga orb o3" aria-hidden="true" />
          <h2>{title ?? <>{t('ctaT1')}<br /><span className="mute">{t('ctaT2')}</span></>}</h2>
          <p>
            {sub ?? (ar
              ? <>طريقة تبادل بيانات الاتصال ما تغيّرت من <span className="num ltr">100</span> سنة. حان وقت التغيير.</>
              : 'The way you exchange contact info hasn’t changed in 100 years. It’s time it did.')}
          </p>
          <div className="ctas">
            <Link className="btn dark lg" to={to}>{btn ?? t('ctaBtn')}<Icon icon={arrow} /></Link>
          </div>
          <a className="asb" href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" aria-label={t('appStore')}>
            <img src="/app-store-badge.svg" alt="Download on the App Store" />
          </a>
          {note ? <div className="note"><span>{t('ctaNote')}</span></div> : null}
        </div>
      </div>
    </section>
  );
}
